import { c as _c } from "react/compiler-runtime";
import type { AuthMethodKind, UserTimelineEventAuthMethodUpdated } from '@onefootprint/request-types/dashboard';
import { Trans, useTranslation } from 'react-i18next';
import InsightEventPopover from '@/components/insight-event-popover';
type AuthMethodUpdatedEventHeaderProps = {
  data: UserTimelineEventAuthMethodUpdated['data'];
};
const AuthMethodUpdatedEventHeader = t0 => {
  const $ = _c(22);
  const {
    data
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "auditTrail.timeline.authMethodUpdated"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t1);
  let t2;
  if ($[1] !== t) {
    t2 = kind => {
      if (kind === "phone") {
        return t(_temp);
      }
      if (kind === "email") {
        return t(_temp2);
      }
      return t(_temp3);
    };
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const getKindLabel = t2;
  const t3 = data.insightEvent;
  let t4;
  if ($[3] !== t) {
    t4 = t(_temp4);
    $[3] = t;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== data.insightEvent || $[6] !== t4) {
    t5 = <span className="inline-block md:contents"><InsightEventPopover insightEvent={t3}>{t4}</InsightEventPopover></span>;
    $[5] = data.insightEvent;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== data.action) {
    t6 = $_3 => $_3.auditTrail.timeline.authMethodUpdated.action[data.action];
    $[8] = data.action;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== data.kind || $[11] !== getKindLabel) {
    t7 = getKindLabel(data.kind);
    $[10] = data.kind;
    $[11] = getKindLabel;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t7) {
    t8 = {
      kind: t7
    };
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      b: <b className="text-label-2 text-primary" />
    };
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t6 || $[17] !== t8) {
    t10 = <p className="inline ml-1 text-body-2 text-tertiary md:block md:ml-0 md:text-nowrap"><Trans ns="entity-details" i18nKey={t6} values={t8} components={t9} /></p>;
    $[16] = t6;
    $[17] = t8;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== t10 || $[20] !== t5) {
    t11 = <div className="md:flex md:items-center md:gap-1 md:flex-wrap">{t5}{t10}</div>;
    $[19] = t10;
    $[20] = t5;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  return t11;
};
export default AuthMethodUpdatedEventHeader;
function _temp($) {
  return $.kind.phone;
}
function _temp2($_0) {
  return $_0.kind.email;
}
function _temp3($_1) {
  return $_1.kind.passkey;
}
function _temp4($_2) {
  return $_2.user;
}